(function () {
  'use strict';

  var STORAGE_KEY = 'ornate_delivery_zip';

  function parseRegionList(value) {
    return String(value || '')
      .split(',')
      .map(function (item) {
        return item.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function matchesRegion(regionCode, configuredList) {
    if (!regionCode || !configuredList || !configuredList.length) return false;
    return configuredList.indexOf(regionCode) !== -1;
  }

  function getStoredRegionDirectly() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return '';

      var data = JSON.parse(raw);

      if (
        !data ||
        !data.region ||
        !data.expiresAt ||
        Date.now() > Number(data.expiresAt)
      ) {
        localStorage.removeItem(STORAGE_KEY);
        return '';
      }

      return String(data.region).trim().toUpperCase();
    } catch (e) {
      return '';
    }
  }

  function getCurrentRegion() {
    var html = document.documentElement;

    var directStoredRegion = getStoredRegionDirectly();
    if (directStoredRegion) return directStoredRegion;

    if (
      window.OrnateDeliveryZip &&
      typeof window.OrnateDeliveryZip.get === 'function'
    ) {
      var stored = window.OrnateDeliveryZip.get();

      if (stored && stored.region) {
        return String(stored.region).trim().toUpperCase();
      }
    }

    return String(html.dataset.region || '').trim().toUpperCase();
  }

  function activateImages(scope) {
    if (!scope) return;

    scope.querySelectorAll('[data-rab-srcset]').forEach(function (el) {
      var srcset = el.getAttribute('data-rab-srcset');

      if (srcset) {
        el.setAttribute('srcset', srcset);
        el.removeAttribute('data-rab-srcset');
      }
    });

    scope.querySelectorAll('[data-rab-src]').forEach(function (el) {
      var src = el.getAttribute('data-rab-src');

      if (src) {
        el.setAttribute('src', src);
        el.removeAttribute('data-rab-src');
      }
    });
  }

  function initOne(root) {
    if (!root || root.__rabInited) return;
    root.__rabInited = true;

    var showOnce = root.getAttribute('data-show-once') === 'true';
    var delay = Number(root.getAttribute('data-delay') || 0) * 1000;
    var storageKey = 'rab_seen_' + (root.id || '');

    try {
      if (showOnce && sessionStorage.getItem(storageKey) === '1') {
        root.style.display = 'none';
        return;
      }
    } catch (e) {}

    var primaryRegions = parseRegionList(root.getAttribute('data-primary-regions'));
    var secondaryRegions = parseRegionList(root.getAttribute('data-secondary-regions'));

    function hideAll() {
      root.querySelectorAll('[data-region]').forEach(function (item) {
        item.classList.add('rab-hidden');
      });
    }

    function showRegion(regionKey) {
      hideAll();

      var active = root.querySelector('[data-region="' + regionKey + '"]');

      if (active) {
        activateImages(active);
        active.classList.remove('rab-hidden');
      }

      try {
        if (showOnce) sessionStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    function decide() {
      var regionCode = getCurrentRegion();

      if (matchesRegion(regionCode, primaryRegions)) {
        showRegion('PRIMARY');
        return;
      }

      if (matchesRegion(regionCode, secondaryRegions)) {
        showRegion('SECONDARY');
        return;
      }

      showRegion('AWAY');
    }

    function run() {
      if (delay > 0) {
        window.setTimeout(decide, delay);
      } else {
        decide();
      }
    }

    run();

    document.addEventListener('ornate:zip-ready', decide);
    document.addEventListener('geo:ready', decide);
  }

  function boot() {
    document.querySelectorAll('[data-rab-root="1"]').forEach(initOne);
  }

  boot();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();